import * as React from 'react';
import { Header2, InlineText1 } from '@cian/ui-kit';

import { ITitleValueListItem } from '../../types/titleValueList';

import * as styles from './styles.css';

interface ITitleValueListProps {
  title?: string;
  items: ITitleValueListItem[];
}

export function TitleValueList({ title, items }: ITitleValueListProps) {
  return (
    <div className={styles['container']}>
      {title && <Header2 as="h2">{title}</Header2>}
      {items.map(({ title, value }) => (
        <div key={title} className={styles['item']}>
          <InlineText1 color="gray60_100">{title}</InlineText1>
          <InlineText1>{value}</InlineText1>
        </div>
      ))}
    </div>
  );
}
